<template>
  <div class="wt-audio-page">
    <layout-general>
      <layout-header slot="header"></layout-header>
      <main-stage slot="main"></main-stage>
      <audio-left-bar slot="left"></audio-left-bar>
      <audio-apply-cancel slot="footer"></audio-apply-cancel>
    </layout-general>
  </div>
</template>

<script>
import LayoutGeneral from 'AssetEditor/layouts/LayoutGeneral.vue';
import AudioLeftBar from 'AssetEditor/functionality/Audio/AudioLeftBar.vue';
import AudioApplyCancel from 'AssetEditor/functionality/Audio/AudioApplyCancel.vue';
import MainStage from 'AssetEditor/functionality/Stage/MainStage.vue';
import LayoutHeader from 'AssetEditor/layouts/LayoutHeader.vue';

export default {
  components: {
    LayoutGeneral,
    AudioLeftBar,
    LayoutHeader,
    AudioApplyCancel,
    MainStage,
  },
};
</script>
